import styled from 'styled-components'

export const ProgressBar = styled('div')`
  background-color: ${({ theme }) => theme.colors.Black50};
  height: 4px;
  width: 100%;
  border-radius: 2px;
  overflow: hidden;
`

export const Progress = styled('div')`
  background-color: ${({ theme }) => theme.colors.Primary};
  height: 4px;
`